import React from 'react'

function FormResponseInfo({ title, children, bodyClass }) {
  return (
    <div className="flex items-center space-x-1 sm:space-x-0 sm:block sm:mb-0 lg:mb-3">
      <h3 className="font-medium text-txt-emphasis">{title}</h3>
      <p className={`text-base sm:text-sm text-txt ${bodyClass}`}>{children}</p>
    </div>
  )
}

export default FormResponseInfo
